var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row form-page-detail-body-container container-app-search" },
    [
      _c(
        "div",
        { staticClass: "table-column" },
        [
          _c(
            "v-client-table",
            {
              staticClass: "jTable",
              attrs: {
                data: _vm.dataColumn,
                columns: _vm.columns,
                options: _vm.table_options
              },
              scopedSlots: _vm._u([
                {
                  key: "is_primary_key",
                  fn: function(props) {
                    return _c(
                      "div",
                      {},
                      [
                        props.row.type === "text"
                          ? _c("j-toggle", {
                              class: {
                                "disabled-primary":
                                  !_vm.showBtnAlterTable ||
                                  (!!_vm.form_data.primary_key &&
                                    props.row.name !==
                                      _vm.form_data.primary_key) ||
                                    _vm.findRecord
                              },
                              attrs: {
                                disabled:
                                  !_vm.showBtnAlterTable ||
                                  (!!_vm.form_data.primary_key &&
                                    props.row.name !==
                                      _vm.form_data.primary_key) ||
                                    _vm.findRecord
                              },
                              on: {
                                input: function($event) {
                                  _vm.setPrimary($event, props)
                                }
                              },
                              model: {
                                value: props.row.is_primary_key,
                                callback: function($$v) {
                                  _vm.$set(props.row, "is_primary_key", $$v)
                                },
                                expression: "props.row.is_primary_key"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  }
                },
                {
                  key: "is_use_regex",
                  fn: function(props) {
                    return _c("div", {}, [
                      props.row.is_use_regex
                        ? _c("span", { staticClass: "text-true" }, [
                            _vm._v("TRUE")
                          ])
                        : _c("span", { staticClass: "text-false" }, [
                            _vm._v("FALSE")
                          ])
                    ])
                  }
                },
                {
                  key: "is_use_validation",
                  fn: function(props) {
                    return _c("div", {}, [
                      props.row.is_use_validation
                        ? _c("span", { staticClass: "text-true" }, [
                            _vm._v("TRUE")
                          ])
                        : _c("span", { staticClass: "text-false" }, [
                            _vm._v("FALSE")
                          ])
                    ])
                  }
                },
                {
                  key: "initial_value",
                  fn: function(props) {
                    return _c("div", {}, [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.row.initial_value || "-") +
                          "\n      "
                      )
                    ])
                  }
                },
                {
                  key: "action",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              props.row.name !== "created_at" &&
                              props.row.name !== "updated_at" &&
                              props.row.name !== "flow_status" &&
                              props.row.name !== "updated_by" &&
                              props.row.name !== "created_by",
                            expression:
                              "props.row.name !== 'created_at' &&\n          props.row.name !== 'updated_at' &&\n          props.row.name !== 'flow_status' &&\n          props.row.name !== 'updated_by' &&\n        props.row.name !== 'created_by'"
                          }
                        ]
                      },
                      [
                        _vm.showBtnAlterTable &&
                        _vm.form_data.type !== "thirdparty"
                          ? _c("img", {
                              staticClass: "cursor-pointer m__r--5",
                              attrs: {
                                src: require("@/assets/icon/query/edit.svg"),
                                width: "13"
                              },
                              on: {
                                click: function($event) {
                                  _vm.openDetail(props)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showBtnAlterTable &&
                        _vm.form_data.type !== "thirdparty"
                          ? _c("img", {
                              staticClass: "cursor-pointer",
                              attrs: {
                                src: require("@/assets/icon/query/delete.svg"),
                                width: "13"
                              },
                              on: {
                                click: function($event) {
                                  _vm.deleteItem(props)
                                }
                              }
                            })
                          : _vm._e()
                      ]
                    )
                  }
                }
              ])
            },
            [
              _c(
                "div",
                {
                  staticClass: "custom-search",
                  attrs: { slot: "beforeFilter" },
                  slot: "beforeFilter"
                },
                [
                  _c(
                    "b-form",
                    { attrs: { inline: "" } },
                    [
                      _vm.showBtnAlterTable &&
                      _vm.form_data.type !== "thirdparty"
                        ? _c(
                            "b-button",
                            {
                              staticClass: "btn grey btn-import-form",
                              on: { click: _vm.openModalColumn }
                            },
                            [
                              _c("i", { staticClass: "fa fa-plus fa-lg" }),
                              _vm._v(" Add\n          ")
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appAddColumnModal",
          staticClass: "mod-form modal-add-column-data",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v(_vm._s(_vm.isDetail ? "UPDATE" : "CREATE") + " COLUMN")
          ]),
          _vm._v(" "),
          _c(
            "b-form-group",
            { class: { "error-input": _vm.$v.column_data.name.$error } },
            [
              _c("label", [_vm._v(" Name ")]),
              _vm._v(" "),
              _c("j-input", {
                attrs: {
                  "error-required": _vm.$v.column_data.name.$error,
                  "max-length": 255,
                  disabled: _vm.isDetail && _vm.findRecord,
                  placeholder: "Name"
                },
                model: {
                  value: _vm.$v.column_data.name.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.column_data.name, "$model", $$v)
                  },
                  expression: "$v.column_data.name.$model"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { class: { "error-input": _vm.$v.column_data.type.$error } },
            [
              _c("label", [_vm._v(" Type ")]),
              _vm._v(" "),
              _c("j-single-select", {
                attrs: {
                  "error-required": _vm.$v.column_data.type.$error,
                  options: _vm.typeOptions,
                  disabled: _vm.isDetail && _vm.findRecord,
                  placeholder: "Type"
                },
                model: {
                  value: _vm.$v.column_data.type.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.column_data.type, "$model", $$v)
                  },
                  expression: "$v.column_data.type.$model"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              class: { "error-input": _vm.$v.column_data.initial_value.$error }
            },
            [
              _c("label", [_vm._v(" Default ")]),
              _vm._v(" "),
              _c("j-input", {
                attrs: {
                  "error-required": _vm.$v.column_data.initial_value.$error,
                  "max-length": 255,
                  placeholder: "Default"
                },
                model: {
                  value: _vm.$v.column_data.initial_value.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.column_data.initial_value, "$model", $$v)
                  },
                  expression: "$v.column_data.initial_value.$model"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c(
                    "b-form-group",
                    {
                      class: {
                        "error-input": _vm.$v.column_data.is_use_regex.$error
                      }
                    },
                    [
                      _c("label", [_vm._v(" Regex ")]),
                      _vm._v(" "),
                      _c("j-toggle", {
                        model: {
                          value: _vm.$v.column_data.is_use_regex.$model,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.$v.column_data.is_use_regex,
                              "$model",
                              $$v
                            )
                          },
                          expression: "$v.column_data.is_use_regex.$model"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c(
                    "b-form-group",
                    {
                      class: {
                        "error-input":
                          _vm.$v.column_data.is_use_validation.$error
                      }
                    },
                    [
                      _c("label", [_vm._v(" Validation ")]),
                      _vm._v(" "),
                      _c("j-toggle", {
                        model: {
                          value: _vm.$v.column_data.is_use_validation.$model,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.$v.column_data.is_use_validation,
                              "$model",
                              $$v
                            )
                          },
                          expression: "$v.column_data.is_use_validation.$model"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.column_data.is_use_validation,
                  expression: "column_data.is_use_validation"
                }
              ]
            },
            [
              _c("label", [_vm._v(" Script ")]),
              _vm._v(" "),
              _vm.openEditor
                ? _c("j-monaco-editor", {
                    ref: "scriptEditor",
                    attrs: {
                      value: _vm.column_data.validation_script,
                      height: "200px"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  class: {
                    "error-input":
                      _vm.$v.column_data.validation_container_variable.$error
                  }
                },
                [
                  _c("label", [_vm._v(" Container Variable ")]),
                  _vm._v(" "),
                  _c("j-input", {
                    attrs: {
                      "error-required":
                        _vm.$v.column_data.validation_container_variable.$error,
                      "max-length": 255,
                      placeholder: "Container Variable"
                    },
                    model: {
                      value:
                        _vm.$v.column_data.validation_container_variable.$model,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.$v.column_data.validation_container_variable,
                          "$model",
                          $$v
                        )
                      },
                      expression:
                        "$v.column_data.validation_container_variable.$model"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  class: {
                    "error-input":
                      _vm.$v.column_data.validation_container_message.$error
                  }
                },
                [
                  _c("label", [_vm._v(" Container Message ")]),
                  _vm._v(" "),
                  _c("j-input", {
                    attrs: {
                      "error-required":
                        _vm.$v.column_data.validation_container_message.$error,
                      "max-length": 255,
                      placeholder: "Container Variable"
                    },
                    model: {
                      value:
                        _vm.$v.column_data.validation_container_message.$model,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.$v.column_data.validation_container_message,
                          "$model",
                          $$v
                        )
                      },
                      expression:
                        "$v.column_data.validation_container_message.$model"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _vm.column_data.type === "custom_class"
            ? _c(
                "div",
                [
                  _c(
                    "v-client-table",
                    {
                      staticClass: "jTable",
                      attrs: {
                        data: _vm.dataColumnGroup,
                        columns: _vm.columns,
                        options: _vm.table_options
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "is_primary_key",
                          fn: function(props) {
                            return _c("div", {}, [
                              props.row.is_primary_key
                                ? _c("span", { staticClass: "text-true" }, [
                                    _vm._v("TRUE")
                                  ])
                                : _c("span", { staticClass: "text-false" }, [
                                    _vm._v("FALSE")
                                  ])
                            ])
                          }
                        },
                        {
                          key: "is_use_regex",
                          fn: function(props) {
                            return _c("div", {}, [
                              props.row.is_use_regex
                                ? _c("span", { staticClass: "text-true" }, [
                                    _vm._v("TRUE")
                                  ])
                                : _c("span", { staticClass: "text-false" }, [
                                    _vm._v("FALSE")
                                  ])
                            ])
                          }
                        },
                        {
                          key: "action",
                          fn: function(props) {
                            return _c("div", {}, [
                              _c("img", {
                                staticClass: "cursor-pointer m__r--5",
                                attrs: {
                                  src: require("@/assets/icon/query/edit.svg"),
                                  width: "13"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.openDetailGroup(props)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "cursor-pointer",
                                attrs: {
                                  src: require("@/assets/icon/query/delete.svg"),
                                  width: "13"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.deleteItemGroup(props)
                                  }
                                }
                              })
                            ])
                          }
                        }
                      ])
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "custom-search",
                          attrs: { slot: "beforeFilter" },
                          slot: "beforeFilter"
                        },
                        [
                          _c(
                            "b-form",
                            { attrs: { inline: "" } },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass:
                                    "btn grey btn-import-form m__r--5",
                                  attrs: { id: "columnGroupAdd" },
                                  on: {
                                    click: function($event) {
                                      _vm.isDetailGroup = false
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-plus fa-lg" }),
                                  _vm._v(" Add\n            ")
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-popover",
                    {
                      ref: "popoverColumnGroup",
                      attrs: {
                        show: _vm.popoverColumnGroupShow,
                        target: "columnGroupAdd",
                        triggers: "click",
                        placement: "right"
                      },
                      on: {
                        "update:show": function($event) {
                          _vm.popoverColumnGroupShow = $event
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "label-create-form-data" }, [
                        _vm._v(
                          _vm._s(_vm.isDetailGroup ? "UPDATE" : "CREATE") +
                            " COLUMN GROUP"
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          class: {
                            "error-input": _vm.$v.column_data_group.name.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Name ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              "error-required":
                                _vm.$v.column_data_group.name.$error,
                              "max-length": 255,
                              placeholder: "Name"
                            },
                            model: {
                              value: _vm.$v.column_data_group.name.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.column_data_group.name,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.column_data_group.name.$model"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          class: {
                            "error-input": _vm.$v.column_data_group.type.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Type ")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              "error-required":
                                _vm.$v.column_data_group.type.$error,
                              options: _vm.typeOptionsGroup,
                              placeholder: "Type"
                            },
                            model: {
                              value: _vm.$v.column_data_group.type.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.column_data_group.type,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.column_data_group.type.$model"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          class: {
                            "error-input":
                              _vm.$v.column_data_group.initial_value.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Default ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              "error-required":
                                _vm.$v.column_data_group.initial_value.$error,
                              "max-length": 255,
                              placeholder: "Default"
                            },
                            model: {
                              value:
                                _vm.$v.column_data_group.initial_value.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.column_data_group.initial_value,
                                  "$model",
                                  $$v
                                )
                              },
                              expression:
                                "$v.column_data_group.initial_value.$model"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c(
                              "div",
                              { staticClass: "float-to-right" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "btn gray m__r--5",
                                    on: { click: _vm.closeCreateColumnGroup }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Close\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "btn blue",
                                    on: { click: _vm.createColumnDataGroup }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Save\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray m__r--5",
                        on: { click: _vm.closeCreateColumn }
                      },
                      [_vm._v("\n            Close\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn blue",
                        on: { click: _vm.createColumnData }
                      },
                      [_vm._v("\n            Save\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7cdac1d9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cdac1d9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/data-manager/jFormColumn.vue
// module id = null
// module chunks = 